import { useAppSelector } from './TypedRedux';

export const useTranslate = () => {
    const language = useAppSelector(state => state.translation.language);

    return (translations: string[]) => translations[language];
};
